import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getDesktopContainerStyle } from '../patterns/desktop-container.mjs';
import { styled } from './factory.mjs';

export const DesktopContainer = /* @__PURE__ */ forwardRef(function DesktopContainer(props, ref) {
  const [patternProps, restProps] = splitProps(props, [])

const styleProps = getDesktopContainerStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })